import { defineNuxtRouteMiddleware } from '#app'
import { prepareRegFlowHashForPulseInit } from '~/utils/location-av-chart-deeplink'

/**
 * Client navigations: clear marketing `#reg-flow` hash so Pulse loads from `data-page`.
 * Full page loads are handled by the SSR bootstrap script on location slug pages.
 */
export default defineNuxtRouteMiddleware((to) => {
  if (!import.meta.client) return

  prepareRegFlowHashForPulseInit({ pathname: to.path, hash: to.hash })
})
